<template>
  <div id="bottom" class="bottom">
    <div class="bottom-case">
      <div class="title-text title-text-line">
        <h4>关于中税</h4>
        <p @click="onGoto('/GYWM')">关于我们</p>
        <p @click="onGoto()">联系我们</p>
      </div>
      <div class="title-text title-text-line">
        <h4>精选服务</h4>
        <p @click="onGoto('/ZCZX')">注册注销</p>
        <p @click="onGoto('/DLJZ')">代理记账</p>
        <p @click="onGoto('/SJBG')">审计报告</p>
        <p @click="onGoto('/SSCH')">税收合规安排</p>
      </div>
      <div class="title-text-line phone-map">
        <!-- <h4>服务热线</h4> -->
        <!-- <p>市区：0571-81022373 18258189820</p> -->
        <div class="map-path">
          <img src="../assets/images/2781.png" alt />
          <!-- <p>市区地址：杭州市拱墅区莫干路789号美都广场A座511-513</p> -->
          <p>市区地址：杭州市下城区绍兴路161号野风现代中心北楼901室</p>
        </div>
        <!-- <p>下沙：0571-88149990 13093793611</p> -->
        <div class="map-path">
          <img src="../assets/images/2781.png" alt />
          <!-- <p>下沙地址：杭州市幸福南路1116号和茂大厦8楼805-810室</p> -->
          <p>下沙地址：杭州市幸福南路1116号和茂大厦8楼810室</p>
        </div>
        <div style="cursor: pointer;" @click="toNext">备案号:浙ICP备15045601号-1</div>
      </div>
      <div class="code-img">
        <img src="../assets/images/code2769.png" alt="code" />
      </div>
      <div class="bottom-right">
        <div class="right-item">
          <img src="../assets/images/phion2781.png" alt />
          <div class="item-msg">
            <p>市区服务热线</p>
            <p class="msg-number">0571-81022373 18258189820</p>
          </div>
        </div>
        <div class="right-item">
          <img src="../assets/images/map2779.png" alt />
          <div class="item-msg">
            <p>下沙服务热线</p>
            <p>0571-88149990 13093793611</p>
          </div>
        </div>
        <div class="right-item">
          <img src="../assets/images/qq2777.png" alt />
          <div class="item-msg">
            <p>QQ</p>
            <p class="msg-number">1478320060</p>
          </div>
        </div>
        <div class="right-item">
          <img src="../assets/images/weixi2780.png" alt />
          <div class="item-msg">
            <p>微信公众号</p>
            <p>浙江中税税务师事务所有限公司</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  methods: {
    onGoto(data) {
      console.log(data);
      if (data) {
        this.$router.push({ path: data });
      }
    },
    toNext(){
      window.open('https://beian.miit.gov.cn')
    }
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  height: 200px;
  border-top: 1px solid rgb(228, 228, 228);
  position: absolute;
  // bottom: 0;
  left: 0;
  right: 0;

  box-sizing: border-box;
  padding-top: 30px;
  // width: 1040px;
  margin: 0 auto;
  // padding-left: 10%;
  // padding-right: 10%;
  .bottom-case {
    width: 1040px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
}
.title-text-line {
  // margin-right: 50px;
  p {
    color: #000;
  }
}
.phone-map {
  width: 200px;
  line-height: 25px;
  .map-path {
    display: flex;
    // align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
      margin-top: 5px;
    }
  }
}
.title-text {
  h4 {
    margin-bottom: 8px;
  }
  p {
    line-height: 20px;
    color: rgb(80, 80, 80);
    cursor: pointer;
  }
  p:hover {
    color: rgb(240, 148, 27);
  }
}
.bottom > div {
  // margin: 0 20px;
}

.code-img {
  width: 150px;
  // margin: 0 20px;
  img {
    width: 100%;
  }
}

.bottom-right {
  // margin-left: 50px;
  display: flex;
  flex-direction: column;
  .right-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img {
      width: 33px;
      margin-right: 10px;
    }
    .item-msg p:nth-child(2) {
      color: #000;
      margin-top: 2px;
    }
    .item-msg .msg-number {
      color: rgb(13, 124, 197);
      // font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue